import React, { useEffect, useState } from 'react';
import { Package } from 'lucide-react';

const ScrollAnimations = () => {
  const [boxes, setBoxes] = useState([]);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const windowHeight = window.innerHeight;
      
      // Generate boxes based on scroll position
      const newBoxes = [];
      const numberOfBoxes = 6; // Increased number of boxes
      
      for (let i = 0; i < numberOfBoxes; i++) {
        const delay = i * 0.15;
        const speed = 0.15 + (i * 0.05);
        const translateY = (scrollPosition * speed) % (windowHeight + 200);
        
        newBoxes.push({
          id: i,
          translateY,
          delay,
          side: i % 2 === 0 ? 'left' : 'right',
          rotation: (scrollPosition * 0.03 * (i + 1)) % 360,
          size: 50 + (i * 15),
          horizontalOffset: (i % 3) * 5
        });
      }
      
      setBoxes(newBoxes);
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Initial call
    
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="fixed inset-0 pointer-events-none z-0 overflow-hidden">
      {boxes.map((box) => (
        <div
          key={box.id}
          className="absolute opacity-15"
          style={{
            [box.side]: `${box.horizontalOffset}%`,
            transform: `translateY(${box.translateY}px) rotate(${box.rotation}deg)`,
            transition: 'transform 0.1s linear',
            top: `-200px`
          }}
        >
          <Package 
            className="text-red-600 drop-shadow-lg" 
            size={box.size}
            strokeWidth={1.5}
          />
        </div>
      ))}
      
      {/* Additional static decorative boxes */}
      <div className="absolute top-20 right-10 opacity-5">
        <Package className="text-red-500" size={80} strokeWidth={1} />
      </div>
      <div className="absolute top-1/3 left-5 opacity-5">
        <Package className="text-red-500" size={100} strokeWidth={1} />
      </div>
      <div className="absolute top-2/3 right-20 opacity-5">
        <Package className="text-red-500" size={70} strokeWidth={1} />
      </div>
    </div>
  );
};

export default ScrollAnimations;
